import { FC, FunctionComponent } from "react";
import { ToastContainer } from "react-toastify";
import MeetSidebar from "../../components/MeetSidebar/MeetSidebar";
import './MeetLayout.scss'
import { JITSI } from "../../utils/constants";
import { useAppSelector } from "../../redux/app/hooks";

interface ProType {
  component: FunctionComponent;
}

const MeetLayout: FC<ProType> = ({ component: Component }) => {

  const { meetService } = useAppSelector((state) => state.auth);
  const { isMeetjoined } = useAppSelector((state) => state.JitsiMeetSlice);
  console.log("[log] Workshop", meetService);

  return (
    <>
      {/* {
        !isOnline ? 
        (
          <div className="disconnectLoader">

            <div className="disconnectLoaderContainer">
              <CircularProgress 
                variant="indeterminate"
                color="warning" 
                size={35}
              />
              <p className="disconnectLoaderText">
                Network disconnected. If you want to use classroom reconnect again...
              </p>
            </div>
          </div>
        ) :
        (
          <> */}
            <div className="meetMainContainer">
              <div className={`meetSidebarContianer ${ (!isMeetjoined && meetService === JITSI) ? "hideMeetSidebarContianer" : "" }`}>
                  <MeetSidebar />   
              </div>
              <div className={meetService === JITSI ? 'jitsiMeetVideoContainer' : 'meetVideoContainer'}>
                <Component />
              </div>
            </div>
            <ToastContainer
              position="top-center"
              autoClose={2000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          {/* </>
        )
      } */}
      
    </>
  );
};
export default MeetLayout;
